import React from "react";

function Comment() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 24 24"
    >
      <path
        fill="#29b6f6"
        d="M20 1.25H4A2.752 2.752 0 001.25 4v11A2.752 2.752 0 004 17.75 1.252 1.252 0 015.25 19v.677a2.727 2.727 0 001.783 2.574 2.771 2.771 0 00.978.18 2.727 2.727 0 002.058-.943l2.9-3.311a1.246 1.246 0 01.94-.427H20A2.752 2.752 0 0022.75 15V4A2.752 2.752 0 0020 1.25z"
        data-original="#29b6f6"
      ></path>
      <g fill="#e1f5fe">
        <circle cx="12" cy="9" r="1.5" data-original="#e1f5fe"></circle>
        <circle cx="8" cy="9" r="1.5" data-original="#e1f5fe"></circle>
        <circle cx="16" cy="9" r="1.5" data-original="#e1f5fe"></circle>
      </g>
    </svg>
  );
}

export default Comment;
